import classNames from 'classnames';

import { useCategoryUrlGenerator, useTopicUrlGenerator } from '../../hooks/useUrlGenerator';
import { createHomeSectionGrid } from '../../lib/blocks';

import RowTitle from '../partials/RowTitle';
import HomePageBlocks, { HomePageBlocksProps } from './HomePageBlocks';

import styles from '../../styles/pages/home-page-dehors.module.css';

function HomePageDehors({ brand, className = null, ...props }: HomePageBlocksProps) {
    const categoryUrl = useCategoryUrlGenerator();
    const topicUrl = useTopicUrlGenerator();
    const blocks = [
        createHomeSectionGrid({
            id: 'dehors-avec-son-chien',
            title: (
                <RowTitle url={topicUrl({ brand: brand.slug, slug: 'chien' })}>
                    Dehors avec son chien
                </RowTitle>
            ),
            query: {
                brand: brand.id,
                topic: ['chien'],
            },
            loading: 'lazy',
            cardImageLoading: 'lazy',
            cardTheme: 'rounded',
            uniqueDocuments: true,
            withBorder: true,
        }),
        createHomeSectionGrid({
            title: (
                <RowTitle url={categoryUrl({ slug: 'famille' })}>Dehors avec sa famille</RowTitle>
            ),
            query: {
                brand: brand.id,
                category: ['famille'],
            },
            loading: 'lazy',
            cardImageLoading: 'lazy',
            cardTheme: 'rounded',
            uniqueDocuments: true,
            withBorder: true,
        }),
    ];
    return (
        <HomePageBlocks
            {...props}
            withBorder
            cardTheme="rounded"
            brand={brand}
            additionalBlocks={blocks}
            className={classNames([styles.container, className])}
            blocksClassName={styles.blocks}
        />
    );
}

export default HomePageDehors;
